module.exports = __webpack_public_path__ + "static/img/banner3.c0b36e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/banner3.jpg
// module id = jTQZ
// module chunks = 1